import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Blogs1 from "../assets/Blog1.webp";
import Blogs2 from "../assets/Blog2.webp";
import Blogs3 from "../assets/Blog3.webp";
import { LazyImageComponent } from "../components/lazyloader/LazyImage";

const blogs = [
  {
    image: Blogs2,
    title: "Personal Loan",
    description: "Our goal is to provide easy-to-use, transparent financial products the .....",
  },
  {
    image: Blogs3,
    title: "Housing Loan",
    description: "Our goal is to provide easy-to-use, transparent financial products the .....",
  },
  {
    image: Blogs2,
    title: "Business Loan",
    description: "Our goal is to provide easy-to-use, transparent financial products the .....",
  },
  {
    image: Blogs1,
    title: "Vehicle Loan",
    description: "Our goal is to provide easy-to-use, transparent financial products the .....",
  },
  {
    image: Blogs1,
    title: "Gold Loan",
    description: "Our goal is to provide easy-to-use, transparent financial products the .....",
  },
  {
    image: Blogs3,
    title: "Loan Against Property ",
    description: "Our goal is to provide easy-to-use, transparent financial products the .....",
  },
];

const OurBlogs = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const getItemsPerPage = () => {
    if (windowWidth >= 1200) return 3;
    if (windowWidth >= 992) return 3;
    if (windowWidth >= 768) return 2;
    if (windowWidth >= 576) return 2;
    return 1;
  };

  const itemsPerPage = getItemsPerPage();
  const totalPages = Math.ceil(blogs.length / itemsPerPage);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => window.scrollTo(0, 0), []);

  const maxVisiblePages = 6;
  const effectiveTotalPages = Math.min(totalPages, maxVisiblePages);

  const visibleBlogs = showAll
    ? blogs
    : blogs.slice(activeIndex * itemsPerPage, (activeIndex + 1) * itemsPerPage);

  useEffect(() => {
    if (showAll) return;
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % effectiveTotalPages);
    }, 2000);
    return () => clearInterval(interval);
  }, [effectiveTotalPages, showAll, itemsPerPage]);

  if (!Array.isArray(blogs) || blogs.length === 0)
    return <div className="text-center">Loading blogs...</div>;

  return (
    <div className="row">
      <div className="col-2 d-none d-lg-block"></div>

      <div className="col-12 col-lg-8">
        <div className="w-100 h-100 mt-3 mt-sm-4 mt-md-5 p-2 p-md-3 mb-4 rounded-4">
          <h1
            className="fw-semibold text-center mb-2 mb-md-3 fs-2 fs-md-1"
            style={{ color: "#444444" }}
          >
            Blogs & Insights
          </h1>

          <p className="text-center text-secondary px-2 px-md-4 mb-3 mb-md-4 fs-6 fs-md-5">
            Let our blogs light the path to stronger financial confidence and better
            <span className="d-none d-md-inline">
              <br />
            </span>
            control over your money.
          </p>

          <div className="d-flex justify-content-center align-items-center mb-3 mb-md-4">
            <button
              onClick={() => navigate("/all-blogs")}
              className="btn text-black fw-semibold px-3 py-2 mt-2 rounded-pill"
            >
              <span className="fs-6 fs-md-5 fs-lg-4 ">View All</span>
            </button>
          </div>

          <div className="row g-2 g-sm-3 g-md-4">
            {visibleBlogs.map((blog, index) => (
              <div key={index} className="col-12 col-sm-6 col-lg-4 mb-3 d-flex">
                <div
                  className="card h-100 w-100"
                  style={{
                    borderRadius: "1rem",
                    background: "#E6EFFD",
                    border: "none",
                  }}
                >
                  <div
                    className="card-img-container position-relative w-100"
                    style={{ height: "200px", overflow: "hidden" }}
                  >
                    <LazyImageComponent
                      src={blog.image}
                      alt={blog.title}
                      className="card-img-top w-100 h-100"
                      style={{
                        borderRadius: "1.25rem 1.25rem 0 0",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div className="card-body p-3">
                    <h5
                      className="card-title bg-white rounded-5 d-inline-block px-3 py-2 mb-2"
                      style={{
                        color: "#0F62FE",
                        fontSize: "0.875rem",
                        border: "2px solid #0F62FE",
                      }}
                    >
                      {blog.title}
                    </h5>
                    <p className="card-text fs-6 text-secondary">
                      {blog.description}
                    </p>

                    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                      <Link
                        to="/blog-article-page"
                        className="text-decoration-none d-flex align-items-center mb-2 mb-sm-0 fw-semibold fs-6"
                        style={{ color: "#4b4b4b" }}
                      >
                        Read More →
                      </Link>
                      <span
                        className="text-muted fs-6"
                        style={{ fontFamily: "poppins" }}
                      >
                        24 March, 2025
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {!showAll && totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              {Array.from({ length: effectiveTotalPages }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActiveIndex(i)}
                  className={`dot-indicator ${i === activeIndex ? "active" : ""}`}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="col-2 d-none d-lg-block"></div>
    </div>
  );
};

export default OurBlogs;
